import { useAppSelector } from './useAppSelector';
import * as referenceSlice from '../data/reference.slice';

export const useTransportationType = (typeId: number | undefined): string => {
  const transportationTypes = useAppSelector(
    referenceSlice.selectTransortationTypes,
  );
  const type = transportationTypes.find(
    (t) => t.transportationTypeID === typeId,
  );
  return type ? type.transportationTypeName : '';
};
